import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dialog, IconButton } from 'react-toolbox';
import { invert } from 'lodash';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import LrrpInfo from './lrrp_info';
import LrrpSignature from './lrrp_signature';
import Loading from 'components/Loading';
import { clearValidation, clearValidationErrors, lrrpCreate, updatePhaseTask } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import {
  STATES_WITH_ABBREV,
  FIRM_NAME,
  CERTIFICATION_NUMBER,
  LRRP_DESCRIPTION,
  WRITTEN_DETERMINATION,
  CERTIFIED_KITS_USED,
  LEAD_TEST_KIT,
  LEAD_TEST_RESULT,
} from 'config/constants';
import S from 'modal.scss';
import styles from 'styles/input.scss';

class SignLrrpModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    isLeadPresent: '',
    signature: '',
    rooms: [],
    errors: {},
    tab: 0,
  }

  static VALIDATIONS = {
    signature: true,
    rooms: true,
  }

  componentDidUpdate = () => {
    if (this.props.active) {
      window.addEventListener('orientationchange', this.checkOrientation, false);
      if (window.orientation !== 0 && this.state.width === 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ width: 1 });
      } else if (window.orientation === 0 && this.state.width !== 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ width: 0 });
      }
    } else {
      window.removeEventListener('orientationchange', this.checkOrientation, false);
    }
  }

  handleClose = () => {
    this.setState({ loading: false });
    this.props.clearValidationErrors('PHASE');
    this.props.onClose();
    window.location.reload();
  }

  updateFormData = (lrrpData) => {
    this.setState(lrrpData, () => {
      if (lrrpData.tab === 3) {
        const { phase: {
          id, customer_name, project_number, street_address, city, state, zip_code,
        } } = this.props;
        const { signature, rooms, isLeadPresent } = this.state;
        this.props.lrrpCreate({
          signature,
          rooms,
          customer_name,
          street_address,
          city,
          zip_code,
          state: invert(STATES_WITH_ABBREV)[state],
          contract_number: project_number,
          firm_name: FIRM_NAME,
          certification_number: CERTIFICATION_NUMBER,
          description: LRRP_DESCRIPTION,
          written_determination: WRITTEN_DETERMINATION,
          certified_kits_used: CERTIFIED_KITS_USED,
          is_lead_present: isLeadPresent,
          test_kit: LEAD_TEST_KIT,
          test_result: LEAD_TEST_RESULT,
          phase_id: id,
        }).then(() => {
          this.props.updatePhaseTask(
            id, 'sign_lrrp', { task: { status: 'complete' } },
          );
        }).then(() => {
          this.handleClose();
        }).catch(() => { });
      }
    });
  }

  showTab = () => {
    setTimeout(() => { if (this.state.tab <= 1) this.setState({ tab: 1 }); }, 600);
    const { phase, leadCertNumber } = this.props;
    const { signature, rooms, isLeadPresent } = this.state;
    switch (this.state.tab) {
      case 1:
        return (<LrrpInfo
          phase={phase}
          updateFormData={this.updateFormData}
          leadCertNumber={leadCertNumber}
          isLeadPresent={isLeadPresent}
          rooms={rooms}
        />);
      case 2:
        return (<LrrpSignature
          phase={phase}
          updateFormData={this.updateFormData}
          signature={signature}
        />);
      default:
        return (<Loading />);
    }
  }

  render = () => {
    const { active, errors: serverErrors } = this.props;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Sign LRRP</h5>
      {this.showTab()}
    </Dialog>);
  }
}

SignLrrpModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  lrrpCreate: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  userName: PropTypes.string.isRequired,
  leadCertNumber: PropTypes.string,
  task: TaskType.isRequired,
  serverErrors: PropTypes.shape({}),
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.arrayOf(PropTypes.string),
  }),
};

SignLrrpModal.defaultProps = {
  active: false,
};

export default connect(
  state => ({
    errors: state.walkthroughs.uploadError,
  }),
  {
    clearValidation,
    clearValidationErrors,
    lrrpCreate,
    updatePhaseTask,
  },
)(SignLrrpModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/index.jsx